module.exports = __webpack_public_path__ + "img/icon-map-pin-1.f51bb371.svg";